import { render, staticRenderFns } from "./ViewImportOrder.vue?vue&type=template&id=2697b070&scoped=true"
import script from "./ViewImportOrder.vue?vue&type=script&lang=js"
export * from "./ViewImportOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewImportOrder.vue?vue&type=style&index=0&id=2697b070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2697b070",
  null
  
)

export default component.exports